import gql from 'graphql-tag';

export default gql`
  mutation generateContentLessonMutation($topic: String!, $lng: String!) {
    generateContentLessonMutation(topic: $topic, lng: $lng) {
      content
    }
  }
`;
